import * as React from 'react'
import View from '@packages/common/src/components/View'
import Form from './Form'
import { CmpStyles } from '@packages/common/src/providers/style/types'

const styles: CmpStyles = {
  box: {
    maxWidth: 400,
    flexDirection: 'column',
    marginHorizontal: 'auto',
  },
}

const RequestPasswordReset = () => (
  <View style={styles.box}>
    <Form />
  </View>
)

export default RequestPasswordReset
